/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'match-adder-with-objects';
const prefix = `${moduleName}.${componentName}`;

export const noEntriesLabel = `${prefix}.noEntriesLabel`;
export const noAvailableMatchesLabel = `${prefix}.noAvailableMatchesLabel`;

export const ENGLISH = {
    [noEntriesLabel]: 'No entries have been added',
    [noAvailableMatchesLabel]: 'No available matches to add',
};
